shadow$provide[285] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Split:{enumerable:true, get:function() {
  return Split;
}}});
var UGLSL = require("../../../util/glsl.js");
var require$_DOT__SLASH_operator_DOT_js = require("./operator.js");
class Split extends require$_DOT__SLASH_operator_DOT_js.Operator {
  static initClass() {
    this.traits = ["node", "bind", "operator", "source", "index", "split"];
  }
  indexShader(shader) {
    shader.pipe(this.operator);
    return super.indexShader(shader);
  }
  sourceShader(shader) {
    shader.pipe(this.operator);
    return super.sourceShader(shader);
  }
  getDimensions() {
    return this._resample(this.bind.source.getDimensions());
  }
  getActiveDimensions() {
    return this._resample(this.bind.source.getActiveDimensions());
  }
  getFutureDimensions() {
    return this._resample(this.bind.source.getFutureDimensions());
  }
  getIndexDimensions() {
    return this._resample(this.bind.source.getIndexDimensions());
  }
  _resample(dims) {
    let dim;
    const {order} = this;
    const {axis} = this;
    const {overlap} = this;
    const {length} = this;
    const {stride} = this;
    const labels = ["width", "height", "depth", "items"];
    const mapped = order.map(x => labels[x - 1]);
    const index = order.indexOf(axis);
    let set = (() => {
      const result = [];
      for (dim of Array.from(mapped)) {
        result.push(dims[dim]);
      }
      return result;
    })();
    const remain = Math.floor((set[index] - overlap) / stride);
    set.splice(index, 1, length, remain);
    set = set.slice(0, 4);
    const out = {};
    for (let i = 0; i < mapped.length; i++) {
      dim = mapped[i];
      out[dim] = set[i];
    }
    return out;
  }
  make() {
    let left;
    super.make();
    if (this.bind.source == null) {
      return;
    }
    const {order} = this.props;
    let {axis} = this.props;
    let {overlap} = this.props;
    const {length} = this.props;
    const permute = order.join("");
    if (axis == null) {
      axis = order[0];
    }
    const index = permute.indexOf(axis);
    const split = permute[index] + ((left = permute[index + 1]) != null ? left : 0);
    const rest = permute.replace(split[1], "").replace(split[0], "0") + "0";
    overlap = Math.min(length - 1, overlap);
    const stride = length - overlap;
    const uniforms = {splitStride:this._attributes.make(this._types.number(stride)),};
    const transform = this._shaders.shader();
    transform.require(UGLSL.swizzleVec4(split, 2));
    transform.require(UGLSL.swizzleVec4(rest, 4));
    transform.require(UGLSL.injectVec4(index));
    transform.pipe("split.position", uniforms);
    transform.pipe(UGLSL.invertSwizzleVec4(order));
    this.operator = transform;
    this.order = order;
    this.axis = axis;
    this.overlap = overlap;
    this.length = length;
    return this.stride = stride;
  }
  unmake() {
    return super.unmake();
  }
  change(changed, touched, _init) {
    if (changed["split.axis"] || changed["split.order"] || touched["operator"]) {
      return this.rebuild();
    }
  }
}
Split.initClass();

};